import * as React from "react";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
  ConstFontStyle,
} from "src/config/styles_const/styles_const";
import styled from "styled-components";
import HeadlineSmall from "../../atom/text/headline_small";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  index?: string;
  title?: string;
  text?: string;
}

const CampaignSection: React.FC<IProps> = (props) => {
  const { index, title, text } = props;

  return (
    <Wrapper>
      <CampaignSectionWrapper>
        <CampaignSectionTitleWrapper>
          <CampaignSectionIndex>{index}</CampaignSectionIndex>
          <CampaignSectionTitle>{title}</CampaignSectionTitle>
        </CampaignSectionTitleWrapper>
        <CampaignSectionTextWrapper>
          <CampaignSectionText bold={true}>{text}</CampaignSectionText>
        </CampaignSectionTextWrapper>
      </CampaignSectionWrapper>
    </Wrapper>
  );
};

export default CampaignSection;

const Wrapper = styled.div`
  width: 100%;
`;

const CampaignSectionWrapper = styled.div`
  margin-bottom: 30px;
`;

const CampaignSectionTitleWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
`;

const CampaignSectionIndex = styled(HeadlineSmall)`
  border-radius: ${ConstBorderRound.LabelUnreadCount};
  background-color: ${ConstColor.circleProgressColorGreen};
  padding: 5px 15px;
  color: ${ConstColor.White};
  margin-right: 20px;
`;

const CampaignMSectionIndex = styled(HeadlineSmall)`
  border-radius: ${ConstBorderRound.LabelUnreadCount};
  background-color: #f2b745;
  padding: 5px 15px;
  color: ${ConstColor.White};
  margin-right: 20px;
`;

const CampaignSSectionIndex = styled(HeadlineSmall)`
  border-radius: ${ConstBorderRound.LabelUnreadCount};
  background-color: #4668e5;
  padding: 5px 15px;
  color: ${ConstColor.White};
  margin-right: 20px;
`;

const CampaignISectionIndex = styled(HeadlineSmall)`
  border-radius: ${ConstBorderRound.LabelUnreadCount};
  background-color: #e5b858;
  padding: 5px 15px;
  color: ${ConstColor.White};
  margin-right: 20px;
`;

const CampaignSectionTitle = styled(HeadlineSmall)`
  padding: 5px 0px;
`;

const CampaignSectionTextWrapper = styled.div`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-left: 60px;
  }
`;

const CampaignSectionText = styled(ParagraphSup)`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    line-height: ${ConstFontStyle.ParagraphDefault.lineHeight};
    font-size: ${ConstFontStyle.MenuParagraphDefault.fontSize};
  }
`;

export const CampaignMSection: React.FC<IProps> = (props) => {
  const { index, title, text } = props;

  return (
    <Wrapper>
      <CampaignSectionWrapper>
        <CampaignSectionTitleWrapper>
          <CampaignMSectionIndex>{index}</CampaignMSectionIndex>
          <CampaignSectionTitle>{title}</CampaignSectionTitle>
        </CampaignSectionTitleWrapper>
        <CampaignSectionTextWrapper>
          <CampaignSectionText bold={true}>{text}</CampaignSectionText>
        </CampaignSectionTextWrapper>
      </CampaignSectionWrapper>
    </Wrapper>
  );
};

export const CampaignSSection: React.FC<IProps> = (props) => {
  const { index, title, text } = props;

  return (
    <Wrapper>
      <CampaignSectionWrapper>
        <CampaignSectionTitleWrapper>
          <CampaignSSectionIndex>{index}</CampaignSSectionIndex>
          <CampaignSectionTitle>{title}</CampaignSectionTitle>
        </CampaignSectionTitleWrapper>
        <CampaignSectionTextWrapper>
          <CampaignSectionText bold={true}>{text}</CampaignSectionText>
        </CampaignSectionTextWrapper>
      </CampaignSectionWrapper>
    </Wrapper>
  );
};

export const CampaignISection: React.FC<IProps> = (props) => {
  const { index, title, text } = props;

  return (
    <Wrapper>
      <CampaignSectionWrapper>
        <CampaignSectionTitleWrapper>
          <CampaignISectionIndex>{index}</CampaignISectionIndex>
          <CampaignSectionTitle>{title}</CampaignSectionTitle>
        </CampaignSectionTitleWrapper>
        <CampaignSectionTextWrapper>
          <CampaignSectionText bold={true}>{text}</CampaignSectionText>
        </CampaignSectionTextWrapper>
      </CampaignSectionWrapper>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/campaign/campaign-section-title.tsx